import React, { Component } from "react";

import { Box, Button, Typography } from "@mui/material";

import schema from "./schema";
import datalink from "./datalink";

import Datumizo from "Components/LabIZO/Datumizo/Datumizo";
import { VStack, HStack } from "Components/LabIZO/Stackizo";
import { Accessor, ColorX, Authority } from "static";

class Promotion extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      title: "PROMOTION MESSAGES",
      serverSidePagination: false,
      base: {
        title: "Promotion messages",
        exportDoc: "Promotion_Messages",
        schema: schema,
        reqAuth: "Promotion",

        tablizo: {
          columnsToolbar: true,
          filterToolbar: true,
          densityToolbar: true,
          exportToolbar: false,
          showSelector: true,
        },

        Connect: {
          DBInfo: datalink.Request.DBInfo,
          List: datalink.Request.List,
          schema: schema.Table,
        },

        operations: {
          Add: {
            title: "Add Promotion Message",
            url: datalink.Request.Add,
            success: "Promotion Message Added Successfully",
            fail: "Promotion Message Add Failed: ",
            schema: schema.Add,
            buttons: ["Clear", "Submit"],
            onSubmit: "Add",
          },
          Delete: {
            title: "Delete this Promotion Message?",
            content: "Caution: This is irrevertable.",
            url: datalink.Request.Delete,
            success: "Promotion Message Deleted Successfully.",
            fail: "Promotion Message Delete Failed: ",
            onSubmit: "Delete",
          },
          Edit: {
            title: "Edit Promotion Message ",
            url: datalink.Request.Edit,
            success: "Promotion Message Edited Successfully",
            fail: "Promotion Message Edit Failed: ",
            schema: schema.Edit,
            buttons: ["Revert", "Submit"],
            onSubmit: "Edit",
          },
          Info: {
            title: "Promotion Message",
            schema: schema.Info,
            readOnly: true,
          },
          DeleteBulk: {
            title: (n) => "Delete these " + n + " Promotion Messages?",
            content: "Caution: This is irrevertable.",
            url: datalink.Request.DeleteBulk,
            success: "Promotion Messages Deleted Successfully.",
            fail: "Promotion Messages Delete Failed: ",
            onSubmit: "DeleteBulk",
          },
          // Export: {
          //   url: datalink.Request.Export,
          //   exportFileType: "xlsx",
          //   addOnsOverride: { workspace: "master" },
          // },
          // Import: {
          //   title: "Promotion Messages Import",
          //   content: "(File size cannot exceed 10MB, only accept .xlsx and .xls)",
          //   url: datalink.Request.Import,
          //   success: "Promotion Messages Imported Successfully.",
          //   fail: "Promotion Messages Import Failed: ",
          //   accept: [".xlsx", ".xls"],
          //   addOnsOverride: { workspace: "master" },
          //   schema: schema.ImportFormat,
          //   replace: false,
          // },
        },

        buttons: {
          inline: [
            { icon: "edit", func: "Edit", caption: "Edit", reqFunc: "Edit" },
            { icon: "info", func: "Info", caption: "Details" },
          ],
          inlineOpposite: [{ icon: "delete", func: "Delete", caption: "Delete", reqFunc: "Delete" }],
          left: [{ icon: "add", func: "Add", caption: "Add Promotion Message", reqFunc: "Add" }],
          right: [
            { icon: "deletebulk", func: "DeleteBulk", caption: (n) => "Delete (" + n + ")", reqFunc: "Delete", theme: "caution" },
            // { icon: "export", func: "Export", caption: (n) => "Export (" + (n === 0 ? "All" : n) + ")", reqFunc: "Export" },
            // { icon: "import", func: "Import", caption: "Import", reqFunc: "Import" },
          ],
        },
      },
    };
  }

  componentDidMount() {
    Authority.Require("Promotion");
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(Promotion.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  render() {
    let { base, serverSidePagination, title } = this.state;
    return (
      <VStack>
        <Box padding={1} width="100%">
          <Typography
            style={{
              textAlign: "left",
              width: "100%",
              fontSize: 25,
              color: ColorX.GetColorCSS("Primary"),
            }}
          >
            {title}
          </Typography>
        </Box>
        <Datumizo base={base} serverSidePagination={serverSidePagination} />
      </VStack>
    );
  }
}

export default Promotion;
